/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./index.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomPagination from "../Pagination";

const SECTION2_COMPLETED = "Section 2 Complete";

const getStatusColor = (status = "") => {
  if (status === "I9 Completed/Start Everify") {
    return "one";
  }
  switch (status) {
    case "Section 1 Initiated":
    case "Section 1 Started":
    case "Section 1 Submitted":
    case SECTION2_COMPLETED:
      return "one";

    case "E-Verify Submitted":
    case "Employment Authorized":
    case "Referred to SSA":
    case "DHS Verification In Process":
    case "Final Nonconfirmation":
      return "two";

    case "Tentative Nonconfirmation (TNC)":
    case "Worker notified of TNC":
    case "Review and Update Employee Data":
    case "SSA or DHS Case in Continuance":
    case "DHS No Show":
      return "three";

    case "Error: Close Case and Resubmit":
      return "four";

    case "Invited":
      return "five";

    default:
      return "noColor";
  }
};

const CustomTable = ({
  columns,
  sortableColumns,
  data,
  order,
  orderBy,
  handleSort,
  showCount = false,
  name,
  hasActions,
  actionsList,
  selectedPage,
  setSelectedPage,
  pagination = false,
  totalPages,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpenedRow, setMenuOpenedRow] = useState(null);
  const [menuActionsList, setMenuActionsList] = useState(actionsList);
  const open = Boolean(anchorEl);

  const handleClick = (event, id) => {
    setMenuOpenedRow(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpenedRow(null);
  };

  useEffect(() => {
    if (menuOpenedRow?.actionsList) {
      setMenuActionsList(menuOpenedRow.actionsList);
      return;
    }
    if (menuOpenedRow) {
      const rowStatus = menuOpenedRow?.i9Status || menuOpenedRow?.status;
      const filteredActionList = actionsList.filter((option) => {
        if (option?.action === "status") {
          return rowStatus !== "Invited";
        }
        if (option?.action === "Edit") {
          return rowStatus !== SECTION2_COMPLETED;
        }
        if (option?.action === "Download I9") {
          return rowStatus === SECTION2_COMPLETED;
        }
        if (option?.action === "Start E-Verify") {
          return rowStatus === SECTION2_COMPLETED;
        }
        return true;
      });
      setMenuActionsList(filteredActionList);
    }
  }, [menuOpenedRow, actionsList]);

  const getActionLabel = (option) =>
    option?.action === "status"
      ? `Make ${name === "comapaniesList" ? "company" : "user"} ${
          menuOpenedRow?.status === "Active" ? "inactive" : "active"
        }`
      : option.action;

  const statusClassNames = {
    Active: "active-cell",
    Inactive: "inactive-cell",
    Invited: "invited-cell",
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {Object.entries(columns).map(([columnKey, columnLabel], index) => (
                <TableCell
                  key={columnKey}
                  className={`column-${columnKey}`}
                  sortDirection={orderBy === columnLabel ? order : false}
                >
                  {sortableColumns?.includes(columnLabel) && (
                    <TableSortLabel
                      active={orderBy === columnLabel}
                      direction={orderBy === columnLabel ? order : "asc"}
                      onClick={(e) => {
                        handleSort(e, columnLabel);
                      }}
                    >
                      {`${columnLabel} ${
                        showCount && index === 0 ? `(${data?.length})` : ""
                      }`}
                    </TableSortLabel>
                  )}
                  {!sortableColumns?.includes(columnLabel) && (
                    <>
                      {`${columnLabel} ${
                        showCount && index === 0 ? `(${data?.length})` : ""
                      }`}
                    </>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {data?.length > 0 ? (
              data?.map((row) => (
                <TableRow
                  key={name + row.id + row?.key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  className={`${row.type === "Child" ? "child-row" : ""}`}
                >
                  {Object.keys(columns).map((columnKey, index) => {
                    if (hasActions && columnKey === "actions") {
                      return (
                        <TableCell
                          key={row.id + index + row?.key}
                          className="action-cell"
                        >
                          <div>
                            <MoreVertIcon
                              onClick={(event) => handleClick(event, row)}
                              className="control-icon align-self-center"
                              key={"icon" + row.id}
                            />
                          </div>
                        </TableCell>
                      );
                    }

                    const isStatusColumn = columnKey === "status";
                    const isStatusInteractive =
                      isStatusColumn && typeof row.statusAction === "function";
                    const statusClass =
                      isStatusColumn
                        ? row?.statusClass ||
                          (["usersList", "comapaniesList"].includes(name)
                            ? statusClassNames[row.status]
                            : getStatusColor(row.status))
                        : "";
                    const isRowActionFn = typeof row?.actions === "function";
                    const cellClassNames = [
                      `column-${columnKey}`,
                      statusClass,
                      isStatusInteractive ? "everify-status-cell" : "",
                      columnKey === "company" && row?.onClick ? "clickable-cell" : "",
                      columnKey !== "status" && columnKey !== "actions" && isRowActionFn ? "clickable-cell" : "",
                    ]
                      .filter(Boolean)
                      .join(" ")
                      .trim();
                    const handleCellClick =
                      columnKey !== "status" && columnKey !== "actions" && isRowActionFn ? row.actions : () => {};

                    return (
                      <TableCell
                        key={row.id + row[columnKey] + row?.key}
                        className={cellClassNames}
                        onClick={handleCellClick}
                      >
                        {isStatusInteractive ? (
                          <button
                            type="button"
                            className="table-status-link"
                            onClick={(event) => {
                              event.stopPropagation();
                              row.statusAction();
                            }}
                          >
                            {row[columnKey]}
                          </button>
                        ) : (
                          row[columnKey]
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={Object.values(columns)?.length}
                  key="NoDataCell"
                  className={`no-data-cell`}
                >
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <CustomPagination
          count={totalPages}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        className="table-action-menu"
        id={"table-action-menu"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              borderRadius: "16px",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
      >
        {menuActionsList?.map((option, ind) => (
          <MenuItem
            key={option?.action + ind}
            onClick={() => {
              handleClose();
              option?.actionClick(option?.action, menuOpenedRow);
            }}
          >
            {getActionLabel(option)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CustomTable;
